const $ = window.jQuery;

Ok.IncognitoOnboarding = {
	init() {
		this.Data = {};

		this.Dom = {
			modal: $("#incognito-upsell"),
			popover: $("#incognito-toggler-popover"),
			document: $(document),
		};

		this.saw_hash = "incognito";
		this.initted = true;

		this.listen();
		this.open();
	},

	listen() {
		this.Dom.popover.on("click tap", ".flatbutton.close", (ev) => {
			ev.preventDefault();
			this.graduate();
		});
		this.Dom.document.on("headerbar.usermenu.open", (ev) => {
			this.closeModal();
			this.graduate();
		});

		// upsell modal
		this.Dom.modal.on("click tap", ".simplecancel", (ev) => {
			ev.preventDefault();
			this.closeModal();
		});
		this.Dom.modal.on("modalclose", (ev) => {
			ev.preventDefault();
			this.reportModalSeen();
		});
	},

	saw(item) {
		if (!Modernizr.history) {
			return false;
		}

		const state =
			(window.history != null ? window.history.state : undefined) || {};

		return state[item];
	},

	markSeen(item) {
		if (!Modernizr.history) {
			return false;
		}

		const state =
			(window.history != null ? window.history.state : undefined) || {};
		state[item] = true;
		window.history.replaceState(state, null, window.location.href);
	},

	open() {
		if (this.Dom.modal.length && !this.saw("upsell")) {
			// Make sure modals are initted by now
			Modal.init();
			this.openModal();
		} else {
			this.openOnboarding();
		}
	},

	openModal() {
		Modal.open(this.Dom.modal.attr("id"));
		ClientStats.update({
			statname: "desktop - incognito - modal - alist upsell - opened",
		});
		userGuides.graduate("INCOGNITO_UPSELL");
	},

	closeModal() {
		Modal.close(this.Dom.modal.attr("id"));
	},

	reportModalSeen() {
		ClientStats.update({
			statname: "desktop - incognito - modal - alist upsell - cancel",
		});
		this.markSeen("upsell");

		// try starting onboarding
		return this.openOnboarding();
	},

	openOnboarding() {
		if (this.saw("onboarding")) {
			return;
		}

		this.Dom.popover.addClass("open");
	},

	closeOnboarding() {
		if (!this.initted) {
			return;
		}

		this.Dom.popover.removeClass("open");
		this.markSeen("onboarding");
	},

	graduate() {
		if (!this.initted) {
			return;
		}

		userGuides.graduate("INCOGNITO_TOGGLER", () => {
			this.closeOnboarding();
		});
	},
};



// WEBPACK FOOTER //
// ./src/legacy/incognito/onboarding.js